var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{staticClass:"background"},[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('Alert'),_vm._v(" "),_c('flash-messages'),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }